<template>
  <b-container>
    <b-row class="mb-2">
      <b-col>
        <h1>Create Menu</h1>
      </b-col>
      <b-col>
        <b-button
          variant="primary"
          class="float-right"
          @click="$router.push('/menus')"
        >
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-overlay :show="loading" no-wrap fixed />
    <b-row v-if="Object.keys(errors).length">
      <b-col class="mb-2" sm="12" lg="6">
        <error-alert :errors="errors" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="6">
        <b-form class="base-form-col" @submit.prevent="onMenuCreate">
          <b-form-group label="Name">
            <b-form-input v-model="name" />
          </b-form-group>
          <custom-search-field
            v-model="hub"
            group-label="Hub"
            :path-to-search="'facilities'"
          />
          <b-form-group label="Tax Rate %">
            <b-form-input
              v-model="taxRate"
              type="number"
              min="0"
              step=".000001"
            />
          </b-form-group>
          <b-button variant="primary" type="submit">Create</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Menu from '../../models/Menu';

export default {
  data() {
    return {
      name: null,
      hub: null,
      taxRate: 0.08875,
      errors: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters('session', ['hubCount']),
  },
  methods: {
    onMenuCreate() {
      const me = this;
      const menu = new Menu({
        name: me.name,
        facility_id: me.hub ? me.hub.id : null,
        tax_rate: me.taxRate,
      });

      me.loading = true;

      menu
        .save()
        .then((response) => {
          me.$router.push({
            name: 'menu',
            params: {
              id: response.getData().data.id,
            },
          });
        })
        .catch((error) => {
          me.loading = false;
          me.errors = error.response.data.errors;
        });
    },
  },
};
</script>
